import { Tooltip } from '@mui/material';
import { StationSalesCellProps } from './StationSalesCell.types';

/**
 * Renders station-level sales data in a grid layout with tooltips
 *
 * @param props - The component props
 * @returns JSX element displaying sales metrics with growth indicators
 */
export const StationSalesCell = ({ sales }: StationSalesCellProps) => {
  const weekGrowth = sales.weekGrowth ?? null;
  const dayGrowth = sales.dayGrowth ?? 0;

  return (
    <div className="sales-grid-container">
      <Tooltip
        title={<div style={{ whiteSpace: 'pre-line', textAlign: 'center' }}>{'Срдн. реал. по НП за\nпот. тиж.'}</div>}
        placement="top"
        enterDelay={200}
        leaveDelay={100}
      >
        <div className="price-value">
          {sales.currentWeekAvg
            ? sales.currentWeekAvg.toLocaleString('uk-UA', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
            : ''}
        </div>
      </Tooltip>
      <Tooltip
        title={
          <div style={{ whiteSpace: 'pre-line', textAlign: 'center' }}>{'Приріст поточного до\nминулого тижня'}</div>
        }
        placement="top"
        enterDelay={200}
        leaveDelay={100}
      >
        <div className="price-value">
          {weekGrowth != null && !!sales.currentWeekAvg ? (
            <span className={weekGrowth > 0 ? 'positive-change' : weekGrowth < 0 ? 'negative-change' : ''}>
              {`${weekGrowth >= 0 ? '+' : ''}${weekGrowth.toFixed(1)}%${weekGrowth > 0 ? '↑' : weekGrowth < 0 ? '↓' : ''}`}
            </span>
          ) : (
            ''
          )}
        </div>
      </Tooltip>
      <Tooltip
        title={<div style={{ whiteSpace: 'pre-line', textAlign: 'center' }}>{'Срдн. реал. по НП за\nпопер. день'}</div>}
        placement="top"
        enterDelay={200}
        leaveDelay={100}
      >
        <div className="price-value">
          {sales.previousDayAvg
            ? sales.previousDayAvg.toLocaleString('uk-UA', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
            : ''}
        </div>
      </Tooltip>
      <Tooltip
        title={
          <div style={{ whiteSpace: 'pre-line', textAlign: 'center' }}>
            {'Приріст попер. дня\nдо відповід. дня мин.\nтижня'}
          </div>
        }
        placement="top"
        enterDelay={200}
        leaveDelay={100}
      >
        <div className="price-value">
          {dayGrowth !== 0 ? (
            <span className={dayGrowth > 0 ? 'positive-change' : dayGrowth < 0 ? 'negative-change' : ''}>
              {`${dayGrowth >= 0 ? '+' : ''}${dayGrowth.toFixed(1)}%${dayGrowth > 0 ? '↑' : dayGrowth < 0 ? '↓' : ''}`}
            </span>
          ) : (
            ''
          )}
        </div>
      </Tooltip>
    </div>
  );
};
